import React from 'react';
import { AnchorButtonProps, Button } from '@components/Button';
import { getCreateWeddingUrl } from '@utils/urlHelpers.util';

export const GetStartedButton: React.FC<Omit<AnchorButtonProps, 'forwardedAs' | 'href'> & {
  page: MarcomPageName | undefined;
  as?: never;
}> = ({ children, page, ...restProps }) => {
  return (
    <Button forwardedAs="a" href={getCreateWeddingUrl(page)} {...restProps}>
      {children}
    </Button>
  );
};
